import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';
import { KEYS } from 'helpers/react-query.config';
import { AxiosServiceError } from 'interfaces/general';

/**
 * Hook para obtener las categorías de estado de tickets disponibles en el sistema.
 *
 * Consulta las categorías de estado de tickets desde el catálogo y maneja errores automáticamente.
 *
 * @returns {object} Query object con los datos de categorías de estado de tickets.
 *
 * @example
 * const ticketStatusCategories = useGetTicketStatusCategory();
 * // ticketStatusCategories.data contendrá las categorías disponibles
 */
export default function useGetTicketStatusCategory() {
  const { catalog: catalogApi } = useApiContext();
  const { showApiError } = useGlobalContext();
  const { t } = useTranslation('global');

  return useQuery(
    KEYS.catalog.ticketStatusCategory.getAll(),
    () => catalogApi.ticketStatusCategory.getAllTicketStatusCategory(),
    {
      refetchOnWindowFocus: false,
      select: (data) => data.data.data,
      onError: (error: AxiosServiceError) => {
        showApiError(error, t('common.commonMessages.genericRequestError'));
      }
    }
  );
}
